module.exports = __webpack_public_path__ + "static/media/st-lucia.a487787b.svg";